module.exports = __webpack_public_path__ + "img/OsavusWhite.7383d3cb.png";